<template>
  <div @click ="itemClick" class="keyboard" style=" max-width: 1015px; display: flow-root;margin: 0 auto;">
    <ul i="0">
        <li adc="" journey="" name="Esc" taskname="Esc">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
            
        </li>
        <li adc="" journey=""  name="F1" taskname="F1">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
            
        </li>
        <li adc="" journey=""  name="F2" taskname="F2">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
            
        </li>
        <li adc="" journey=""  name="F3" taskname="F3">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="F4" taskname="F4">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="F5" taskname="F5">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="F6" taskname="F6">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="F7" taskname="F7">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="F8" taskname="F8">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="F9" taskname="F9">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="F10" taskname="F10">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="F11" taskname="F11">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="F12" taskname="F12">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
    </ul>
    <ul i="6">
        <li adc="" journey=""  name="Prt" taskname="PRINTSCREEN">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="Scr" taskname="SCROLLLOCK">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="Pau" taskname="PAUSE">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
    </ul>

    <ul i="1" class="clear">
        <li adc="" journey=""  name="~" taskname="TILDE">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="1" taskname="U1">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="2" taskname="U2">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="3" taskname="U3">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="4" taskname="U4">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="5" taskname="U5">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="6" taskname="U6">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="7" taskname="U7">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="8" taskname="U8">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="9" taskname="U9">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="0" taskname="U0">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="-" taskname="MINUS">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="+" taskname="EQUAL">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="Backspace" taskname="Backspace">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
    </ul>

    <ul i="7" class="clear">
        <li adc="" journey=""  name="Num" taskname="NUMLOCK">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="/" taskname="NUMSLASH">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="*" taskname="NUMSTAR">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="-" taskname="NUMMINUS">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="7" taskname="Num 7">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="8" taskname="Num 8">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="9" taskname="Num 9">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="+" taskname="NUMPLUS">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="4" taskname="Num 4">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="5" taskname="Num 5">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="6" taskname="Num 6">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="1" taskname="Num 1">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="2" taskname="Num 2">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="3" taskname="Num 3">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="Ent" taskname="NUMENTER">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="0" taskname="Num 0">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="." taskname="NUMPERIOD">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
    </ul>
    <ul i="8" class="clear">
        <li adc="" journey=""  name="Ins" taskname="INSERT">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="HM" taskname="HOME">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="PU" taskname="PAGEUP">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="Del" taskname="DELETE">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="End" taskname="END">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="PD" taskname="PAGEDOWN">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
    </ul>

    <ul i="2" class="clear">
        <li adc="" journey=""  name="Tab" taskname="Tab">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="Q" taskname="Q">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="W" taskname="W">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="E" taskname="E">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="R" taskname="R">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="T" taskname="T">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="Y" taskname="Y">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="U" taskname="U">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="I" taskname="I">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="O" taskname="O">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="P" taskname="P">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="[" taskname="LBRACKET">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="]" taskname="RBRACKET">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="\" taskname="BACKSLASH">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
    </ul>

    <ul i="3" class="clear">
        <li adc="" journey=""  name="CapsLock" taskname="CAPSLOCK">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="A" taskname="A">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="S" taskname="S">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="D" taskname="D">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="F" taskname="F">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="G" taskname="G">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="H" taskname="H">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="J" taskname="J">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="K" taskname="K">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="L" taskname="L">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name=";" taskname="SEMICOLON">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="'" taskname="QUOTE">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="Enter" taskname="Enter">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
    </ul>
    <ul i="4" class="clear">
        <li adc="" journey=""  name="LSHIFT" taskname="LSHIFT" >
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="Z" taskname="Z">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="X" taskname="X">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="C" taskname="C">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="V" taskname="V">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="B" taskname="B">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="N" taskname="N">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="M" taskname="M">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="," taskname="COMMA">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="." taskname="PERIOD">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="/" taskname="SLASH">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="RSHIFT" taskname="RSHIFT" >
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
    </ul>

    <ul i="9" class="clear">
        <li adc="" journey=""  name="Up" taskname="Up">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="Lf" taskname="Left">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="Do" taskname="Down">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="Rg" taskname="Right">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
    </ul>

    <ul i="5" class="clear">
        <li adc="" journey=""  name="LCTRL" taskname="LCTRL" >
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="LWIN" taskname="LWIN" >
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="LALT" taskname="LALT" >
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="Space" taskname="Space">
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="RALT" taskname="RALT" >
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        
        <!-- <li adc="" journey=""  name='RWIN' >
            <div class='button_attr'>
                
                <h3></h3>
                <p></p>
            </div>
        </li> -->
        <li adc="" journey=""  name="FN" taskname="FN" >
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="Menu" taskname="Menu" >
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
        <li adc="" journey=""  name="RCTRL" taskname="RCTRL" >
            <div class="button_attr">
                
                <h3></h3>
                <p></p>
            </div>
        </li>
    </ul>
  </div>
</template>


<script>

import "../../asserts/css/buttonTabPane/button.css"

export default {
  name: 'buttonPaneC',
  components: 
  {

  },
  data() {

    return {}
  },
  methods: 
  {
    itemClick(event)
    {
        let keyName = event.target.getAttribute("taskname");
        this.$emit('child-event',keyName);
    }
  }
}

</script>